module.exports = __webpack_public_path__ + "img/ivana-square.a7842ce3.jpg";